@if ( attributes.headline) {
    <h2 kb-heading type="divider">{{attributes.headline}}</h2>
}

<ul>
    @for (link of attributes.items; track link) {
    <li>
        <a kb-icon [icon]="iconMap[link.attributes.icon]" icon-uppercase icon-center
            [attr.aria-label]="link.attributes.icon" [kbRouterOrExternalLink]="link.attributes.url" target="_blank"></a>
    </li>
    }
</ul>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
